import { Component, ComponentInterface, h, Prop } from '@stencil/core';

declare const assetPath;

@Component({
  tag: 'st-icon',
  shadow: false,
})
export class StIcon implements ComponentInterface {

  @Prop() cssClass: string;
  @Prop() icon: string;

  render() {
    return (
      <svg class={this.cssClass}>
        <use xlinkHref={`${assetPath}/icon/sheets/icons.svg#${this.icon}`}></use>
      </svg>
    );
  }

}
